export const firebaseConfig = {
    apiKey: "AIzaSyAD8xVwREyaZUs5MvM2RRm69fwT_3M_-Y8",
    authDomain: "applegrowers-5e4cd.firebaseapp.com",
    databaseURL: "https://applegrowers-5e4cd.firebaseio.com",
    projectId: "applegrowers-5e4cd",
    storageBucket: "applegrowers-5e4cd.appspot.com",
    messagingSenderId: "145373054143"
};



// WEBPACK FOOTER //
// ./firebaseConfig.ts